export default __webpack_public_path__ + "static/media/specialities.c8f2df78.jpg";